module.exports = __webpack_public_path__ + "media/select3.a60bcaa9.mp3";